import axios from 'axios';

import { MainUrl } from "../constants"

const API_URL = `${MainUrl}`


export const UploadFood = async (token, file) => {
  try{
    const formData = new FormData();
    formData.append('file', file)
    const response = await axios.post(`${API_URL}/food/upload/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`
      }
    })
  return response.data
  }

  catch (error) {
    console.log(error)
    // return error.response
  }
}


export const DeleteCombo = async (token, ComboId) => {
  const response = await axios.delete(`${API_URL}/combo/${ComboId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};


export const GetAllSelectedFoodByRepastId = async (token, repastId) => {
  const response = await axios.get(`${API_URL}/repast_food/${repastId}/selected_food/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};



export const getAllCombo = async (token) => {
  const response = await axios.get(`${API_URL}/combo/all_combo/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};

export const getAllFood = async (token) => {
    

  const response = await axios.get(`${API_URL}/food/`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
};


export const getAllFieldsCombo = async (token, comboId) => {
  const response = await axios.get(`${API_URL}/combo_field/fields_combo/${comboId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
}

export const getAllFoodFieldsCombo = async (token, fieldId) => {
  const response = await axios.get(`${API_URL}/field_food/${fieldId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
}

export const getFoodName = async (token, foodId) => {
  const response = await axios.get(`${API_URL}/food/${foodId}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
}


export const createCombo = async (token, name, minHours) => {
  let bodyRequest = {
    name: name,
    area_id: 1,
    min_hours: minHours,
    active: true
  }
  const response = await axios.post(`${API_URL}/combo/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
}

export const createFieldCombo = async (token, comboId, name) => {
  let bodyRequest = {
    name: name,
    combo_id: comboId
  }
  const response = await axios.post(`${API_URL}/combo_field/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
}

export const AddFoodForField = async (token, fieldId, foodId) => {
  let bodyRequest = {
    field_id: fieldId,
    food_id: foodId
  }
  const response = await axios.post(`${API_URL}/field_food/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
}

export const CreateFood = async (token, name) => {
  let bodyRequest = {
    name: name
  }
  const response = await axios.post(`${API_URL}/food/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
}

export const CreateRepastCombo = async (token, comboId) => {
  try {let bodyRequest = {
    combo_id: comboId
  }
  const response = await axios.post(`${API_URL}/repast_combo/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
  }
  catch(error){
    console.log(error.response)
    return error.response
  }
  
}

export const CreateRepastFoods = async (token, data) => {
  const response = await axios.post(`${API_URL}/repast_food/`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
}

export const GetOpenCombo = async (token) => {
  const response = await axios.get(`${API_URL}/combo/access_combo/`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
}


export const GetUserRepastFoodByDate = async (token, data) => {
  try {
    console.log(data)
    const response = await axios.post(`${API_URL}/repast_combo/user_repast_food/`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
    return response.data
  }
  catch(error){
    console.log(error.response)
    return error.response
  }

}


export const GetReportFood = async (token, startDate, endDate) => {
  try {
    let bodyRequest = {
      start_date: startDate,
      end_date: endDate,
    }
  const response = await axios.post(`${API_URL}/reports/repast_food/`, bodyRequest, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    responseType: 'blob' 
    }
  );
    return response
  }
  catch (error){
    if (error.status == 401){
      localStorage.removeItem('token');
      localStorage.removeItem('access_level');
      window.location.href = '/';
    }
  }
  
}